// 正版 Fuelio 图标 —— 紫色 squircle + 白 F + 右上发光小球。
//
// 跟 apps/marketing/public/assets/brand/fuelio-icon.svg 视觉一致，但精简成
// React 组件方便在 admin 后台各处复用（侧栏 / 登录页 / 任何需要的位置）。
// 不要换成 brand/fuelio-mark.svg（那是旧版蓝色闪电，已经被弃用）。
//
// 渐变 ID 加 React 实例 id 后缀避免一个页面里多次渲染时 SVG defs 互相覆盖。
import { useId } from 'react'

interface Props {
  size?: number
  className?: string
}

export function FuelioIcon({ size = 32, className }: Props) {
  const uid = useId()
  const bgId = `fui-bg-${uid}`
  const fgId = `fui-fg-${uid}`
  const spId = `fui-sp-${uid}`
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 1024 1024"
      role="img"
      aria-label="Fuelio"
      className={className}
    >
      <defs>
        <linearGradient id={bgId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#3B1F94"/>
          <stop offset="100%" stopColor="#1F0E5B"/>
        </linearGradient>
        <linearGradient id={fgId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%"  stopColor="#C7B6FF"/>
          <stop offset="55%" stopColor="#FFFFFF"/>
          <stop offset="100%" stopColor="#E8DCFF"/>
        </linearGradient>
        <radialGradient id={spId} cx="0.5" cy="0.5" r="0.5">
          <stop offset="0%"   stopColor="#FFFFFF" stopOpacity="1"/>
          <stop offset="55%"  stopColor="#C7B6FF" stopOpacity="0.7"/>
          <stop offset="100%" stopColor="#9F7BFF" stopOpacity="0"/>
        </radialGradient>
      </defs>
      {/* macOS Big Sur squircle: corner radius ≈ 22.37% × side */}
      <rect width="1024" height="1024" rx="229" fill={`url(#${bgId})`}/>
      <g transform="translate(128 128) scale(12)">
        <g fill={`url(#${fgId})`}>
          <rect x="14" y="10" width="10" height="44" rx="3"/>
          <rect x="14" y="10" width="34" height="10" rx="3"/>
          <rect x="14" y="27" width="22" height="9"  rx="3"/>
        </g>
        <circle cx="52" cy="14" r="14" fill={`url(#${spId})`} opacity="0.7"/>
        <circle cx="52" cy="14" r="6"  fill="#FFFFFF"/>
      </g>
    </svg>
  )
}
